import MpHighlightJs from './widgets/highlight-code/Widget.js';
import MpCodeEditor from './widgets/code-editor/Widget.js';
import MpHtmlEditor from './widgets/html-editor/Widget.js';
import MpIntlTelInput from './widgets/intl-tel-input/Widget.js';
import MpSymfonyCollection from './widgets/symfony-collection/Widget.js';
import MpUploadButton from './widgets/upload-button/Widget.js';
import MpAjaxUploader from './widgets/ajax-uploader/Widget.js';
import MpSeoMetafields from './widgets/seo-metafields/Widget.js';
import MpImageCanvas from './widgets/image-canvas/Widget.js';
import MpImageCrop from './widgets/image-crop/Widget.js';
import MpRangeSlider from './widgets/range-slider/Widget.js';

/**
 * @type {{ [key: string]: DynamicWidgetInterface }}
 */
export default {
	MpCodeEditor,
	MpHtmlEditor,
	MpHighlightJs,
	MpIntlTelInput,
	MpSymfonyCollection,
	MpUploadButton,
	MpAjaxUploader,
	MpSeoMetafields, // <-- this should come after MpHtmlEditor because it is used by it
	MpImageCanvas,
	MpImageCrop,
	MpRangeSlider,
};